import React from 'react'
import { Row, Col, Button, HeadingText, BodyText } from '@paypalcorp/pp-react'

import { Message, injectWorldReady } from '@paypalcorp/worldready-react'
import { Link } from 'react-router-dom'

function CreateLiveApp() {
  return (
    <>
      <Row>
        <Col xs={10} className="banner-title_row">
          <HeadingText size="sm">
            <Message id="onboarding-banner.createLiveAppTitle" />
          </HeadingText>
        </Col>
      </Row>
      <Row>
        <Col xs={7}>
          <BodyText>
            <Message id="onboarding-banner.createLiveAppText1" />
          </BodyText>
          <br />
          <BodyText>
            <Message id="onboarding-banner.createLiveAppText2" />
          </BodyText>
        </Col>
      </Row>

      <Row>
        <Col style={{ marginTop: '40px' }}>
          <Button size="md" secondary as={Link} to="/applications/live/create">
            <Message id="onboarding-banner.createLiveAppButton" />
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default injectWorldReady(CreateLiveApp)
